import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase/firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { Box, Button, TextField, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const EditCarouselItemPage = () => {
  const { itemId } = useParams();
  const [carouselItem, setCarouselItem] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCarouselItem = async () => {
      const itemDoc = doc(db, 'carouselItems', itemId);
      const itemSnapshot = await getDoc(itemDoc);
      if (itemSnapshot.exists()) {
        setCarouselItem(itemSnapshot.data());
      }
    };
    fetchCarouselItem();
  }, [itemId]);

  const handleUpdateCarouselItem = async () => {
    const itemDoc = doc(db, 'carouselItems', itemId);
    await updateDoc(itemDoc, carouselItem);
    navigate('/admin');
  };

  if (!carouselItem) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4 }}>
        <CircularProgress />
        <Typography variant="h5" sx={{ mt: 3, textAlign: 'center' }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>Edit Carousel Item</Typography>
      <TextField label="Title" value={carouselItem.title} onChange={(e) => setCarouselItem({ ...carouselItem, title: e.target.value })} fullWidth />
      <TextField label="Description" value={carouselItem.description} onChange={(e) => setCarouselItem({ ...carouselItem, description: e.target.value })} fullWidth />
      <TextField label="Image URL" value={carouselItem.imageUrl} onChange={(e) => setCarouselItem({ ...carouselItem, imageUrl: e.target.value })} fullWidth />
      <Button variant="contained" onClick={handleUpdateCarouselItem}>Update Carousel Item</Button>
    </Box>
  );
};

export default EditCarouselItemPage;